module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_location_dream_center-4f1f1de431258c9ad6edc5ffc6e6aae4.jpg";